export enum MonetizationEventsEventType {
  SPORTS = 'SPORTS',
  METAGAMES = 'METAGAMES',
}

export interface UserMonetizationEvent {
  id: string;
  userId: string;
  eventId: string;
  gameId: number;
  widgetImageUrl: string;
  providerType: string;
  gameNameType: string;
  manualOptIn: boolean;
  optInDate: string | null;
  balance: number;
  startDate: Date;
  endDate: Date;
}

export interface MonetizationEventsResponse {
  monetizationEvents: UserMonetizationEvent[];
}

export interface MonetizationEventsCurrentEvent extends UserMonetizationEvent {
  url?: string;
  token?: string;
  path?: string;
}
